<template>
  <div
    :class="{
      'bottom-sidenav-logo-container': true,
      'cursor-pointer': !isOnSCDC,
    }"
    @click="handleLogoClicked"
  >
    <div class="bottom-sidenav-logo">
      <p>Powered by</p>
      <base-image :src="logoUrl" class="px-2" />
    </div>
  </div>
</template>

<script>
import {
  LIFETRAQ_LOGO_URL,
  LIFETRAQ_URL,
  TRAQIFY_LOGO_URL,
  TRAQIFY_URL,
} from "Consts/static";
import BaseImage from "Public/components/BaseImage";
import { isTraqify } from "Shared/helpers/isTraqify";
import { isSCDC } from "Shared/helpers/isSCDC";

export default {
  name: "BottomLogo",
  components: { BaseImage },
  computed: {
    isOnSCDC() {
      return isSCDC();
    },
    isOnTraqify() {
      return isTraqify();
    },
    logoUrl() {
      if (this.isOnTraqify) return TRAQIFY_LOGO_URL;
      return LIFETRAQ_LOGO_URL;
    },
  },
  methods: {
    handleLogoClicked() {
      if (this.isOnSCDC) return;
      if (this.isOnTraqify) {
        window.open(TRAQIFY_URL, "_blank");
        return;
      }
      window.open(LIFETRAQ_URL, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~PublicStyles/_variables.scss";
.bottom-sidenav-logo-container {
  position: fixed;
  bottom: 0;
  margin-bottom: 4vh;
  width: 100%;

  .bottom-sidenav-logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      max-height: 40px;
      max-width: 180px;
    }

    p {
      font-family: "Ubuntu", sans-serif;
      font-size: 12px;
      margin-bottom: 15px;
    }
  }
}
</style>
